export const styles = {
  FormControlLabel: {
    marginBottom: '-0.5rem',
  },
  FormHelperText: {
    margin: '0 0 1rem 4.1rem',
  },
  checkboxOutline: {
    color: '#8FC3FF',
  },
  labelCheckMark: {
    height: '1.2rem',
    width: '1.2rem',
    margin: '0 0 .5rem .3rem',
  },
  setupStatusBanner: {
    padding: '0.75rem 1rem',
    borderLeft: '3px solid #D32F2F',
    marginBottom: '1.5rem',
    backgroundColor: '#FFF8F8',
  },
  setupStatusBannerTitle: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#D32F2F',
    marginBottom: '0.5rem',
    fontFamily: 'Roboto',
  },
  setupStatusBannerItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0.5rem',
    fontSize: '14px',
    fontFamily: 'Roboto',
  },
  setupStatusBannerDot: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: '#D32F2F',
    marginRight: '8px',
    flexShrink: 0,
  },
  setupStatusBannerText: {
    color: '#354052',
  },
};
